module.exports = __webpack_public_path__ + "static/sophie-808f76ff7ce798b43d3e352b5e76c96c.jpg";